import { Injectable } from '@angular/core';
import { Device } from '@ionic-native/device';
import { AngularFireDatabase } from '@angular/fire/database';

import { tableNames, propertyNames } from '../../app/app.constants';
import { GlobalVars } from '../../app/app.environment';
import { FirebaseProvider } from '../firebase/firebase';

@Injectable()
export class ConfigurationProvider {

  constructor(
    public afDatabase: AngularFireDatabase,
    public device: Device,
    public firebaseService: FirebaseProvider,
    public globalVars: GlobalVars,
  ) {}

  /**
   * Registrar dispositiu de l'usuari actual.
   */
  registerDevice(): Promise<any> {
    return new Promise((resolve, reject) => {
      if(this.globalVars.user.uuid_device == null) {
        if(this.device.uuid == null) {
          reject('El dispositivo actual no puede registrarse.')
        }
        else {
          this.firebaseService.set(this.getBaseRoot() + tableNames.User + '/' + this.globalVars.user.key, propertyNames.UUID_device, this.device.uuid).then(() => {
            resolve(`Dispositiu registrat correctament.`);
          }).catch((err) => {
            reject(`Error al registrar dispositivo`);
          });
        }
      }

      else reject('Ya existe un dispositivo registrado.');
    })
  }

  /**
   * Arrel base dins la base de dades.
   */
  private getBaseRoot(): string {
    return tableNames.Repo + '/' + this.globalVars.user.repo + '/';
  }

}



// WEBPACK FOOTER //
// ./src/providers/configuration/configuration.ts